<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.4998 3.40156L7.06646 8.8349C6.42479 9.47656 6.42479 10.5266 7.06646 11.1682L12.4998 16.6016" stroke="currentColor" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
